module.exports = __webpack_public_path__ + "static/media/quiz.6a4fa288.png";